window._define('widgets/popOut', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';
    var widgetName = 'popOut',
        selectorClass = 'js-popOut',
        hasDocumentClickCatcher = false,
        currentOpened;

    // widget definition
    $.widget('OC.' + widgetName, BaseWidget, {
        options: {
            triggerEvent: 'auto',
        },

        _create: function () {
            this._super(selectorClass);

            this.options.triggerEvent = this._getEventName();
            this.elements.$button = this.getWidgetElement('button');
            this.isOpened = false;
            this.isEnabled = true;

            this.close();

            this._attachEvents();
        },

        _attachEvents: function () {

            if (!this._hasAttachedEvents) {
                if (this.options.triggerEvent === 'hover') {
                    this.elements.$button.on('mouseenter.popOut', $.proxy(this._onMouseEnter, this));
                    this.element.on('mouseleave.popOut', $.proxy(this._onMouseLeave, this));
                } else {
                    this.elements.$button.on(this.options.triggerEvent + '.popOut', $.proxy(this._onClick, this));
                }
                this._hasAttachedEvents = true;
            }

            if (!hasDocumentClickCatcher) {
                $(document).on('click.popOut', function (event) {
                    var $target = $(event.target),
                        isButton = $target.closest('.js-popOut-button').length > 0,
                        isContent = $target.closest('.js-popOut-content').length > 0;

                    if (currentOpened && !isButton && !isContent) {
                        currentOpened.close();
                    }
                });

                hasDocumentClickCatcher = true;
            }
        },

        _detachEvents: function () {
            this.elements.$button.off('mouseenter.popOut');
            this.element.off('mouseleave.popOut');
            this.elements.$button.off(this.options.triggerEvent + '.popOut');

            this._hasAttachedEvents = false;
        },

        _getEventName: function () {
            var returnValue = 'click';

            if (this.isTouch()) {
                returnValue = 'tap';
            } else {
                if (this.options.triggerEvent !== 'click') {
                    returnValue = 'hover';
                }
            }

            return returnValue;
        },

        _onMouseLeave: function () {
            this.close();
        },

        _onMouseEnter: function () {
            this.open();
        },

        _onClick: function (event) {
            event.preventDefault();
            this.toggle();
        },

        toggle: function () {
            if (this.isOpened) {
                this.close();
            } else {
                this.open();
            }
        },

        disable: function () {
            this._detachEvents();
            this.close();
            this.isEnabled = false;
        },

        enable: function () {
            this._attachEvents();
            this.isEnabled = true;
        },

        open: function () {
            if (this.isEnabled) {
                if (currentOpened) {
                    currentOpened.close();
                }

                this._trigger('onBeforeOpen');

                this.element.addClass('is-opened');
                this.isOpened = true;

                currentOpened = this;
            }
        },

        close: function () {
            if (this.isEnabled) {
                this.element.removeClass('is-opened');
                this.isOpened = false;
            }
        },
    });

    $('.' + selectorClass)[widgetName]();

    $(document).on('click', function (event) {
        var $target = $(event.target),
            isButton = $target.closest('.js-popOut-button').length > 0,
            isContent = $target.closest('.js-popOut-content').length > 0;

        if (currentOpened && !isButton && !isContent) {
            currentOpened.close();
        }
    });
    
    return $.OC[widgetName];
});
